import React from 'react'
import { Check } from 'lucide-react'

// ─────────────────────────────────────────────────────────────────────────────
// Checkbox + Radio , both follow the same 18×18 visual mark + label layout.
//
//   <Checkbox checked={x} onChange={fn} label="…"/>
//   <Radio checked={x} onChange={fn} label="…" name="grp" value="a"/>
//   <RadioGroup name="g" value={v} onChange={setV}
//               options={[{ value: 'a', label: 'A' }, …]} />
// ─────────────────────────────────────────────────────────────────────────────

export function Checkbox({ checked, onChange, label, disabled, className = '' }) {
  return (
    <label className={'flex items-center gap-2 cursor-pointer ' + (disabled ? 'opacity-50 cursor-not-allowed ' : '') + className}>
      <input
        type="checkbox"
        checked={!!checked}
        onChange={e => onChange && onChange(e.target.checked)}
        disabled={disabled}
        className="sr-only peer"
      />
      <span
        className={
          'w-[18px] h-[18px] rounded-[5px] border grid place-items-center transition-colors flex-shrink-0 ' +
          (checked ? 'border-[#e85d1f] bg-[#e85d1f]' : 'border-[#d6d3cb] bg-white')
        }
      >
        {checked && <Check size={11} strokeWidth={3} className="text-white"/>}
      </span>
      {label && <span className="text-[13px] text-[#1a1816]">{label}</span>}
    </label>
  )
}

export function Radio({ checked, onChange, label, name, value, disabled, className = '' }) {
  return (
    <label className={'flex items-center gap-2 cursor-pointer ' + (disabled ? 'opacity-50 cursor-not-allowed ' : '') + className}>
      <input
        type="radio"
        checked={!!checked}
        onChange={() => onChange && onChange(value)}
        name={name}
        value={value}
        disabled={disabled}
        className="sr-only peer"
      />
      <span
        className={
          'w-[18px] h-[18px] rounded-full bg-white border-[1.5px] grid place-items-center transition-colors flex-shrink-0 ' +
          (checked ? 'border-[#e85d1f]' : 'border-[#d6d3cb]')
        }
      >
        {checked && <span className="w-[8px] h-[8px] rounded-full bg-[#e85d1f]"/>}
      </span>
      {label && <span className="text-[13px] text-[#1a1816]">{label}</span>}
    </label>
  )
}

export function RadioGroup({ name, value, onChange, options, className = '' }) {
  return (
    <div className={'flex flex-col gap-2 ' + className}>
      {options.map(o => (
        <Radio
          key={o.value}
          name={name}
          value={o.value}
          label={o.label}
          checked={value === o.value}
          onChange={onChange}
        />
      ))}
    </div>
  )
}
